import React from 'react'
import { Modal, Button } from 'antd'
import { routersHelper } from '../helpers'
import { useSelector } from 'react-redux'
import { IconHelper } from '../helpers'
import { translate } from 'react-i18next'

const PopupStatus = ({ t }) => {
    const popupStatus = useSelector(state => state.backgroundRunning.popupStatus)
    const { IconStatusErr } = IconHelper
    const { useRouter } = routersHelper
    const router = useRouter()
    const { query: { message } } = router

    const getIcon = () => {
        switch (popupStatus.status) {
            case 'error':
                return <IconStatusErr style={{
                    margin: '0 auto'
                }} />
            default:
                return null;
        }
    }

    const setRedText = () => {
        switch (message) {
            case 'error_text_2':
                return 'red-text'
            default:
                return '';
        }
    }

    return (
        <Modal
            title={popupStatus.header ? popupStatus.header : null}
            visible={popupStatus.isShow}
            closable={false}
            footer={<Button onClick={popupStatus.action} type="primary" className="btn-popup-status">OK</Button>}
            className="popup-status"
        >
            <div className="popup-status-body">
                <div className="popup-status-icon">
                    {getIcon()}
                </div>
                <div className="popup-show-msg">
                    <p className="popup-status-main">{t('error_text_main')}</p>
                    <p className={`popup-status-text ${setRedText()}`}> {t(popupStatus.body)}</p>
                </div>
            </div>

        </Modal >
    )
}

export default translate()(PopupStatus)

